import { useState, useEffect, createContext, useContext } from 'react';
import { useCookies } from 'react-cookie';

const AuthContext = createContext(null);

export const useAuthContext = () => {
    return useContext(AuthContext);
};

export const AuthProvider = props => {
    const [cookies] = useCookies();
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        cookies.jwt ? setIsAuthenticated(true) : setIsAuthenticated(false);
    }, [cookies.jwt]);

    return <AuthContext.Provider value={[isAuthenticated, setIsAuthenticated]}>{props.children}</AuthContext.Provider>;
};
